export default "__VITE_ASSET__DL0ouHsZ__"